// extracted by mini-css-extract-plugin
export default {"breadcrumbBarContainer":"catalog-BreadcrumbBar-module__breadcrumbBarContainer","mfeBreadcrumbBar":"catalog-BreadcrumbBar-module__mfeBreadcrumbBar"};